import { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import classNames from 'classnames'
import Card from 'components/card'
import Link from 'components/link'
import { InfoButton } from 'components/buttons'
import { LinkRegistyIcon } from 'components/icons'
import { registryExternalPath } from 'lib/urls'
import css from './feed-items.scss'
import { SectionHeading } from '../../../../components/headings'

class LinkAndTransferCard extends PureComponent {
  render() {
    const { ctaText, title } = this.props

    return (
      <Link url={registryExternalPath}>
        <Card
          className={classNames(css.iconLayout, css.linkAndTransfer, 'mbxl')}
        >
          <div className={css.info}>
            <LinkRegistyIcon width={80} />
            <SectionHeading className="h3 mvl text-bold text-body">
              {title}
            </SectionHeading>
            <InfoButton className="mtm" pill>
              {ctaText}
            </InfoButton>
          </div>
        </Card>
      </Link>
    )
  }
}

LinkAndTransferCard.propTypes = {
  ctaText: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
}

export default LinkAndTransferCard
